<template>
  <div id="app" :class="{ 'custom-background': customerBackground == true }">
    <!-- <DoOmYogaLogin v-if="isLogin==null && $route.fullPath.includes('doom_yoga')" />
    <DoOmYogaHome v-else-if="isLogin!=null && $route.fullPath.includes('doom_yoga')" >
    </DoOmYogaHome>
    <MIDLogin  v-else-if="isLogin==null && $route.fullPath.includes('my_irish_date')"/> 
    <MIDHome v-else-if="isLogin!=null && $route.fullPath.includes('my_irish_date')"  />
    <div v-else>
      <router-link to="/doom_yoga" class="testA">Doom yoga home</router-link>
    </div> -->
    <DoOmYogaHome v-if="isLogin != null &&
      $route.fullPath.includes('doom_yoga') &&
      isCustomer == null
      ">
    </DoOmYogaHome>
    <DoOmYogaCustomerIndex v-else-if="(isLogin != null &&
      $route.fullPath.includes('doom_yoga') &&
      isCustomer == 'true') ||
      (isLogin == null &&
        $route.fullPath.includes('doom_yoga') &&
        $route.name == 'DoOmYogaCustomerHome') ||
      (isLogin == null &&
        $route.fullPath.includes('doom_yoga') &&
        $route.name == 'DoOmYogaCustomerEventsCalendar')
      ">
    </DoOmYogaCustomerIndex>
    <MIDHome v-else-if="isLogin != null && $route.fullPath.includes('my_irish_date')" />
    <DoorderHome v-else-if="isLogin != null && $route.fullPath.includes('doorder')" />
    <GardenHelpHome v-else-if="isLogin != null && $route.fullPath.includes('garden_help') && user_type == 'admin'" />
    <GardenHelpContractorHome
      v-else-if="isLogin != null && $route.fullPath.includes('garden_help') && user_type == 'operator'" />
    <GardenHelpCustomerHome
      v-else-if="isLogin != null && $route.fullPath.includes('garden_help') && user_type == 'user'" />
    
   
    <AstrologyHome v-else-if="isLogin != null &&
      $route.fullPath.includes('astrology') &&
      isCustomer == null
      ">
    </AstrologyHome>
    <AstrologyCustomerIndex v-else-if="(isLogin != null &&
      $route.fullPath.includes('astrology') &&
      isCustomer == 'true') ||
      (isLogin == null &&
        $route.fullPath.includes('astrology') &&
        $route.name == 'AstrologyCustomerHome') ||
      (isLogin == null &&
        $route.fullPath.includes('astrology') &&
        $route.name == 'AstrologyCustomerCreateBirthChartIndex')
      ">
    </AstrologyCustomerIndex>
    <router-view v-else />
  </div>
</template>

<script>
import $ from 'jquery'
import axios from "axios";
import DoOmYogaLogin from "@/components/doom_yoga/auth/LoginView";
import DoOmYogaHome from "@/components/doom_yoga/Home";
import DoOmYogaCustomerIndex from "@/components/doom_yoga/customer/Index";
import MIDHome from "@/components/my_irish_date/Home";
import MIDLogin from "@/components/my_irish_date/auth/LoginView";
import DoorderHome from "@/components/doorder/Home";
import DoorderLogin from "@/components/doorder/auth/LoginView";
import AstrologyHome from "@/components/astrology_ventures/HomeAdmin";
import AstrologyLogin from "@/components/astrology_ventures/auth/LoginView";
import AstrologyCustomerIndex from "@/components/astrology_ventures/customer/Index";
import GardenHelpHome from "@/projects/garden_help/AdminHome"
import GardenHelpContractorHome from "@/projects/garden_help/ContractorHome"
import GardenHelpCustomerHome from "@/projects/garden_help/CustomerHome"
import GardenHelpLogin from "@/projects/garden_help/auth/LoginView"


export default {
  name: "App",
  components: {
    DoOmYogaLogin,
    DoOmYogaHome,
    DoOmYogaCustomerIndex,
    MIDHome,
    MIDLogin,
    DoorderHome,
    DoorderLogin,
    AstrologyHome,
    AstrologyLogin,
    AstrologyCustomerIndex,
    GardenHelpHome, GardenHelpContractorHome, GardenHelpCustomerHome, GardenHelpLogin
  },
  data() {
    return {
      isLogin: window.localStorage.getItem("user"),
      isCustomer: window.localStorage.getItem("customer"),
      customerBackground: false,
      user_type: window.localStorage.getItem("user_type")
    };
  },
  beforeMount() {
    // console.log(axios.defaults.baseURL);
    // console.log(process.env)
    if (this.$route.fullPath.includes("doom_yoga")) {
      axios.defaults.baseURL = process.env.AXIOS_DEFAULT_BASE_URL_DY;
    } else if (this.$route.fullPath.includes("astrology")) {
      axios.defaults.baseURL = process.env.AXIOS_DEFAULT_BASE_URL_AV;
    } else if (this.$route.fullPath.includes("doorder")) {
      axios.defaults.baseURL = process.env.AXIOS_DEFAULT_BASE_URL_DOORDER;
    } else if (this.$route.fullPath.includes("my_irish_date")) {
      axios.defaults.baseURL = process.env.AXIOS_DEFAULT_BASE_URL_MID;
    }
    // console.log(axios.defaults.baseURL);
  },
  mounted() {
    if (
      (this.$route.fullPath.includes("doom_yoga") ||
        this.$route.fullPath.includes("astrology")) &&
      window.localStorage.getItem("customer") != null &&
      window.localStorage.getItem("customer") == "true"
    ) {
      this.customerBackground = true;
    } else {
      this.customerBackground = false;
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue